<template>
    <div>
        <el-button
        :color="bgColor"
        style="width: 100%;height: 34px;margin-top: 5px"
        :style="{'background-color':isClicked1?bgColor:'#ffffff','border-color':isClicked1?borderColor:'#BDBDBD','color':'#333333'}"
        plain
         @click='btnFun()'
        >
           <slot ></slot>
        </el-button>
    </div>
</template>

<script>
// import { isDark } from '~/composables/dark'
export default {
  name: 'myButton',
  props: {
    bgColor: {
      type: String,
      default: '#ffffff'
    },
    borderColor: {
      type: String,
      default: '#BDBDBD'
    },
    isClicked: {
      type: Boolean,
      default: false
    },
    poorBtn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isClicked1: false
    }
  },
  watch: {
    isClicked (newval, oldval) {
      console.log('newval', newval)
      this.isClicked1 = newval
    }
  },
  methods: {
    btnFun () {
      // this.isClicked = !this.isClicked
      if (this.$store.state.list.length !== 0 && !this.poorBtn) {
        this.isClicked1 = !this.isClicked1
        this.$emit('clickFun')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-button{
    justify-content:left;
    div{
        margin-right: 10px;
    }
    border-color: #BDBDBD;
    font-weight: 700;
            font-size: 16px;
 }
 .cricle{
    width:20px;
    height:20px;
    background:#ffffff;
    border-radius:50%;
    margin-right:20px ;
 }
 .select{
    font-size: 20px;
    margin-right: 10px;
 }
</style>
